import * as Yup from 'yup';
import i18n from '../../i18n';
export default class ValidationRules {
    static requiredDate(message: string) {
        return Yup
        .object()
        .required(message)
        .test({
            name: 'validDateString',
            test: (value: any) => value.isValid(),
            message: i18n.t('forms.date_val')
        })
    }

    static optionalDate() {
        return Yup
        .object()
        .nullable()
        .test({
            name: 'validDateString',
            test: (value: any) => value.isValid(),
            message: i18n.t('forms.date_val')
        })
    }
}
